<template>
    <div id="app">
        <div class="header">
            <div class="logo_img" @click="logoClick">
                <div style="display:flex; align-items: center; float:left; height: 70px;">
                    <div class="header-logo">
                        <img id="header-img" src="../../static/other/logo.png" >
                    </div>
                </div>
            </div>
            <div id="menu_index">
                <!-- web端菜单导航 -->
                <el-menu v-if="seen" :default-active="activeIndex" class="el-menu-demo" menu-trigger="click" text-color="#333" style="height: 70px; border:0;" mode="horizontal" @select="handleSelect">
                    <el-menu-item index="1" class="header-title">首页</el-menu-item>
                    <el-menu-item index="4" class="header-title">应用简介</el-menu-item>
                    <el-menu-item index="2" class="header-title">关于我们</el-menu-item>
                    <el-menu-item index="3" class="header-title">联系我们</el-menu-item>
                    <el-menu-item index="5" class="header-title">隐私政策</el-menu-item>
                    <el-menu-item index="6" class="header-title">登录注册</el-menu-item>
                </el-menu>
                <!-- 手机端菜单导航 v-bind:style="{backgroundColor:'#409EFF'}" -->
                <el-menu v-if="!seen" :default-active="activeIndex" class="el-menu-demo" menu-trigger="click" text-color="#333" style="height: 70px; border:0;" mode="horizontal" @select="handleSelectMobile">
                    <el-submenu index="1" class="header-title mobile_menu">
                        <template slot="title">{{currentMenu}}</template>
                        <el-menu-item index="1" class="header-title">首页</el-menu-item>
                        <el-menu-item index="4" class="header-title">应用简介</el-menu-item>
                        <el-menu-item index="2" class="header-title">关于我们</el-menu-item>
                        <el-menu-item index="3" class="header-title">联系我们</el-menu-item>
                        <el-menu-item index="5" class="header-title">隐私政策</el-menu-item>
                        <el-menu-item index="6" class="header-title">登录注册</el-menu-item>
                    </el-submenu>
                </el-menu>
            </div>
            
            
        </div>
        <div class="container" style="clear: both;">
            <router-view></router-view>
        </div>

        <div class="footer">
            <el-row>
                <el-col :xs="24" :sm="24" class="footer_text">
                    <p class="footer_font">联系电话：13866656666</p>
                    <p class="footer_font">地址：江苏省南京市江北新区泰山街道丽岛路21号13幢503室</p>
                </el-col>
                <el-col :xs="24" :sm="24" class="footer_text">
                    <p class="footer_font">备案号：
                        <a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank">苏ICP备2025164696号</a></p>
                    <p class="footer_font">版权所有者：南京福沐源大数据科技有限公司</p>
                </el-col>
                <el-col :xs="24" :sm="24">
                    <div class="footer_bottom">
                        <img src="../../static/other/message.png"/>
                    </div>
                </el-col>
            </el-row>
        </div>
        <!-- 返回顶部 -->
        <!-- <div id="back_to_top" ref="btn" @click="backTop" style="display: none;">
            <p style="font-size: 0.625em; font-weight: bold">TOP</p>
            <img src="../assets/other/launch.png" style="height: 45px;width: 35px" />
        </div> -->
    </div>
</template>

<script>
    export default {
        name: "Layout",
        data() {
            return {
                activeIndex: '1',
                company:{
                    qrcode: require("../../static/other/公众号二维码.jpg"),
                },
                scroll: '',
                timer: '',
                seen: true,
                currentMenu:'首页'
            };
        },
        methods: {
            handleSelect(key) {
                switch (key){
                    case '1':
                        this.$router.push({name: "Index"});
                        break;
                    case '2':
                        this.$router.push({name: "About"});
                        break;
                    case '3':
                        this.$router.push({name: "Contact"});
                        break;
                    case '4':
                        this.$router.push({name: "Intro"});
                        break;
                    case '5':
                        this.$router.push({name: "Protocol"});
                        break;
                    case '6':
                        this.$router.push({name: "Login"});
                        break;
                }
            },
            handleSelectMobile(key) {
                switch (key){
                    case '1':
                        this.$router.push({name: "Index"});
                        this.currentMenu='首页';
                        break;
                    case '2':
                        this.$router.push({name: "About"});
                        this.currentMenu='关于我们';
                        break;
                    case '3':
                        this.$router.push({name: "Contact"});
                        break;
                    case '4':
                        this.$router.push({name: "Intro"});
                        break;
                    case '5':
                        this.$router.push({name: "Protocol"});
                        break;
                    case '6':
                        this.$router.push({name: "Login"});
                        break;
                }
            },
            
            
            login(){
                window.open('https://admin.fastice-tech.com/login')
            },
            register(){
                window.open('https://admin.fastice-tech.com/registe')
            },
            menuSeen(){
                // 屏幕尺寸
                let screenHeight=document.body.clientWidth;
                if(screenHeight>415){
                    this.seen=true;
                }else{
                    this.seen=false;
                }
            },
            logoClick(){
                this.$router.push({name: "Index"});
                this.currentMenu='首页';
            }
        },
        mounted() {
            this.menuSeen()
            window.addEventListener('scroll', this.handleScroll)
        },
    }
</script>

<style scoped>

    .logo_img{
        float:left;
        width: 30%;
        cursor: pointer;
    }
    #back_to_top{
        position: fixed;
        bottom: 50px;
        right: 30px;
        cursor: pointer
    }
    .header-title{
        font-size: 1em;
    }
    .footer{
        /* width: 90%; */
        padding: 15px 0 0 0 !important;
        background: #2c3233;
        color: #fff;
    }
    .footer_font{
        font-size: 1em;
    }
    .footer_font a{
        color: #fff;
    }
    .footer_font a:hover{
        color: #ddd;
    }
    #menu_index{
        float: right; width: 40%;height: 100%
    }
    .header{
        margin: auto;
        width: 90%;
        height: 70px;
        /*background: #F56C6C;*/
    }
    @media screen and (max-device-width: 415px) {
        .logo_img{
            float:left;
            width: auto;
            cursor: pointer;
        }
        #back_to_top{
            position: fixed;
            bottom: 50px;
            right: 5px;
            cursor: pointer
        }
        .footer_font{
            font-size: 0.875em;
        }
        #menu_index{
            float: right;
            width: auto;
            height: 100%
        }
        .mobile_menu{

        }
        .header-title{
            padding: 0 10px;
        }
        .footer_bottom img{
            width: 50% !important;
        }
        .footer_text{
            display: flex;
            justify-content: space-evenly;
            margin: 0 !important;
            padding-left:10px;
            flex-direction: column;
        }
        .footer_font{
            margin: 0;
        }
    }
    #header-img{
        width: 60px;
        height: 60px;
        float: left;
        margin: auto;
    }
    .header-logo{
        height: 50px;
        width: 50px;
        align-self: center;
    }
    .header-important{
        float: left;
        margin-left: 6px;
        align-self: center;
    }

    .footer{
        display: flex;
        align-items: center;
        flex-direction: column;
        margin: 0 auto;
        width: 100%;
    }
    .footer_text{
        display: flex;
        justify-content: space-evenly;
        margin: -10px 0;
    }
    .footer_bottom{
        text-align: center;
        margin-bottom: 20px;
    }
    .footer_bottom img{
        width: 30%;
    }
    a{text-decoration: none;}
    a:visited{text-decoration: none;}
    a:hover {text-decoration: none;}
    a:active{text-decoration:none;}
</style>